<template>
  <div>
    <div class="container">
      <div v-if="showMessage" class="text-center">
        <div>
          <img class="succes-item" src="../../assets/assets_loyalty/garrapata.png">
        </div>
        <div>
          <h2 class="title-modal-success">¡Listo!</h2>
        </div>
        <div>
          <p class="text-modal-success">Te hemos enviado un correo para validar tu cuenta</p>
        </div>
      </div>
      <div  v-if="!showMessage" class="col justify-content-center">
        <div>
          <div class="label-title row">
            <label>Nombre:</label>
          </div>
          <div class="row input-area">
            <input id="name-input" class="new-input" type="text" v-model="nameRegistry">
          </div>
        </div>
        <div>
          <div class="label-title row">
            <label>Apellidos:</label>
          </div>
          <div class="row input-area">
            <input id="lastname-input" class="new-input" type="text" v-model="lastnameRegistry">
          </div>
        </div>
        <div>
          <div class="label-title row">
            <label>Correo:</label>
          </div>
          <div class="row input-area">
            <input id="email-input" class="new-input" type="text" v-model="emailRegistry">
          </div>
        </div>
        <div>
          <div class="label-title row">
            <label>Celular:</label>
          </div>
          <div class="row input-area">
            <input id="phone-input" class="new-input" type="text" v-model="celRegistry">
          </div>
        </div>
        <div class="sex-input-area">
          <div class="row">
            <label class="label-title">Sexo:</label>
            <div class="row">
              <div class="cheked-input-sex-area">
                <input class="cheked-input-sex" type="radio" id="Mujer" name="drone" value="f" checked v-model="sexPicked">
                <label for="Mujer">Mujer</label>
              </div>
              <div>
                <input class="cheked-input-sex" type="radio" id="Hombre" name="drone" value="m" v-model="sexPicked">
                <label for="Hombre">Hombre</label>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="label-title row">
            <label >Código postal:</label>
          </div>
          <div class="row input-area">
            <input id="cp-input" class="new-input" type="text" v-model="CPRegistry">
          </div>
        </div>
        <div class="date-input-area">
          <div class="row">
            <p class="label-title">Fecha de nacimiento:</p>
          </div>
          <div id="date-input" class="row">
            <el-date-picker   v-model="datePicker" type="date" placeholder="AAAA-MM-DD"></el-date-picker>
          </div>
        </div>
        <div>
          <div class="row">
            <vue-recaptcha class="captchatNew" ref="recaptcha" @verify="markRecaptchaAsVerified" sitekey="6LdlXLwUAAAAAHouUjujMEM-7Ec4_Gz0RkDmS5Xv" :loadRecaptchaScript="true"></vue-recaptcha>
          </div>
        </div>
        <div>
          <div class="alert-danger text-center">{{emptyfield}}</div>
          <div class="alert-success text-center">{{registrySuccessfull}}</div>
        </div>
        <div v-if="!showBotton" class="row">
          <button class="green-button btn-round check-in-button" @click="checkRegistryForm()">Registrar</button>
        </div>
        <div v-if="showBotton" class="row">
          <button class=" btn-round check-in-button btn-style">
            <img class="loader-gif" src="../../../public/img/Rolling.gif">
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Button, FormGroupInput, Modal,  Alert} from '@/components';
import MainFooter from '@/layout/MainFooter';
import moment from 'moment';
import {DatePicker} from 'element-ui'
import VueRecaptcha from 'vue-recaptcha';
import LoginService from '../../service/core/login.service';

export default {
  name: 'registry',
  data() {
    return {
      modals: {
        classic: false,
      },
      loginService: new LoginService(),
      errors: '',
      showMessage: false,
      showBotton: false,
      correct: '',
      emptyfield: '',
      registrySuccessfull: '',
      //Registry
      nameRegistry: '', 
      lastnameRegistry: '',
      emailRegistry: '',
      celRegistry: '',
      sexRegistry: '',
      CPRegistry: '',
      datePicker: '',
      captchatMarck: false,
      sexPicked:'',

    };
  },
  bodyClass: 'login-page',
  components: {
    Card,
    Alert,
    MainFooter,
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [DatePicker.name]: DatePicker,
    VueRecaptcha
  },
  methods:{
    checkForm(e) {
      var account_element = document.getElementById('account');
      var password_element = document.getElementById('password');

      if (!this.account && !this.password){
        this.errors = 'Por favor, llena todos los campos';
        account_element.classList.add("has-danger");
        password_element.classList.add("has-danger");
      }else if (this.account && this.password) {
        this.errors = '';
        account_element.classList.add("correct2");
        password_element.classList.add("correct2");
        // return true
      }

      e.preventDefault();
      this.loginService.login(sessionStorage.getItem('accountTk')).then(data => {
        sessionStorage.setItem('accountTk', data.data.token);
      })
    },
    checkForm2(e) {
      e.preventDefault();
    },
    markRecaptchaAsVerified(response) {
      this.pleaseTickRecaptchaMessage = '';
      this.captchatMarck = true;
    },
    showOffMessage(){
      this.showMessage = false;
    },
    checkRegistryForm(){
      this.showBotton = true
      if(this.nameRegistry == ''){
        this.showBotton = false
        document.getElementById("name-input").classList.add("error-date-input")
        this.emptyfield = 'Por favor, introduce los campos marcados';
      }else{
        document.getElementById("name-input").classList.remove("error-date-input")
        this.emptyfield = '';
      } 
      if (this.lastnameRegistry == ''){
        this.showBotton = false
        document.getElementById("lastname-input").classList.add("error-date-input")
        this.emptyfield = 'Por favor, introduce los campos marcados';
      }else{
        document.getElementById("lastname-input").classList.remove("error-date-input")
        this.emptyfield = '';
      } 
      if (this.emailRegistry == ''){
        this.showBotton = false
        document.getElementById("email-input").classList.add("error-date-input")
        this.emptyfield = 'Por favor, introduce los campos marcados';
      }else{
        document.getElementById("email-input").classList.remove("error-date-input")
        this.emptyfield = '';
      } 
      if (this.celRegistry == ''){
        this.showBotton = false
        document.getElementById("phone-input").classList.add("error-date-input")
        this.emptyfield = 'Por favor, introduce los campos marcados';
      }else{
        document.getElementById("phone-input").classList.remove("error-date-input")
        this.emptyfield = '';
      } 
      if(this.sexPicked == ''){
        this.showBotton = false
        document.getElementById("Mujer").classList.add("error-date-input")
        document.getElementById("Hombre").classList.add("error-date-input")
        this.emptyfield = 'Por favor, introduce los campos marcados';
      }else{
        document.getElementById("Mujer").classList.remove("error-date-input")
        document.getElementById("Hombre").classList.remove("error-date-input")
        this.emptyfield = '';
      } 
      if (this.CPRegistry == ''){
        this.showBotton = false
        document.getElementById("cp-input").classList.add("error-date-input")
        this.emptyfield = 'Por favor, introduce los campos marcados';
      }else{
        document.getElementById("cp-input").classList.remove("error-date-input")
        this.emptyfield = '';
      } 
      if (this.datePicker == ''){
        this.showBotton = false
        document.getElementById("date-input").classList.add("error-date-input")
        this.emptyfield = 'Por favor, introduce los campos marcados';
      }else{
        document.getElementById("date-input").classList.remove("error-date-input")
        this.emptyfield = '';
        if(this.captchatMarck === false){
        this.showBotton = false
          this.emptyfield = 'Marcar Captcha';
        }else{
          let registryData = {
            "account":{
              "email": this.emailRegistry,
              "cel": this.celRegistry,
              "name": this.nameRegistry,
              "lastname": this.lastnameRegistry,
              "zip_code": this.CPRegistry,
              "birthday": moment(this.datePicker).format('YYYY-MM-DD'),
              "gender": this.sexPicked
            }
          }
          
          this.loginService.registryNewAccount(registryData).then(data => {
            this.showBotton = false
            this.showMessage = true;
            // setTimeout(this.showOffMessage(), 5000);
          }, error => {
            this.showBotton = false
            let errorCatch = error['message']
            if(errorCatch.includes('402')){
              this.emptyfield = 'Es necesario que capture un correo o un teléfono valido para el registro';
            } else if(errorCatch.includes('403')){
              this.emptyfield = 'El Correo capturado ya existe';
            } else if(errorCatch.includes('405')){
              this.emptyfield = 'El Número celular capturado ya existe';
            }else{
              this.emptyfield = 'Tuvimos un error al registrar tu cuenta, intentalo mas tarde'
            }
          })
          this.emptyfield = '';
        }
      } 
    }
  }
};
</script>
<style lang="scss">
#javascriptComponents {
  .modal-buttons,
  .popover-buttons,
  .tooltip-buttons {
    .btn + .btn {
      margin-left: 3px;
    }
  }
}
.row-height{
  height: 450px;
}
.email-input{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.password-input{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.input-button{
  width: 35%;
  height: 50px;
  color: white;
  font-size: 17px;
  font-weight: bold;
  background-color: #00bbff;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 2px solid #ffffff;
}
.f-password{
  text-align: right;
}
.has-danger{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #FF6E6E;
}
.correct2{
  border-bottom: 2px solid #00FF00;
}
.correct{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #004DFF;
}
.title-input{
  color: #00bbff;
  font-weight: normal;
}
.name-input{
  width: 100%;
  background-color: white;
  font-size: 15px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.bd-select{
  margin: 15px 0px 0px 4px;
  width: 65px;
  height: 30px;
  font-size: 14px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 2px solid #ECECEC;
}
.sexo-input{
  width: 100%;
  height: 30px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 2px solid #ECECEC;
}
.error{
  border-bottom: 2px solid #FF6E6E;
}
.captchat{
  background-color: red;
  height: 60px;
  color: #ffffff;
}
.new-input{
  width: 100%;
  padding: 0px;
  background-color: transparent;
  margin-left: 0px;
  border: 1px;
  border-bottom: 2px solid rgba(236, 236, 236, 0);
}
.captchatNew{
  margin: 15px 0px 20px 60px;
}
.check-in-button{
  width: 100%;
  border: 0px;
  margin-top: 10px;
}

.error-date-input{
-webkit-box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
-moz-box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
}

.label-title{
  color: rgb(172, 172, 172);
  font-size: 13px;
  padding: 0px;
}

.input-area{
  margin-top: -25px;
}
.cheked-input-sex{
  margin: 5px;
}
.cheked-input-sex-area{
  margin-right: 80px;
  margin-left: 90px
}
.sex-input-area{
  margin-top: 25px;
  margin-bottom: 15px;
  color:  rgb(107, 107, 107);
}

.date-input-area{
  margin-top: 10px;
  margin-bottom: 15px;
}

.succes-item{
  width: 100px;
}

.title-modal-success{
  margin: 15px;
  color: #00bbff;
  font-weight: bold;
}

.text-modal-success{
  color: #00bbff;
  font-weight: bold;
}

.loader-gif{
  width: 30px;
}

.green-button{
  background-color: #6b8140;
  color: #ffffff;
  font-weight: bold;
}
@media screen and (min-width: 321px) and (max-width: 768px) { 
  .cheked-input-sex-area{
    margin-right: 10px;
    margin-left: 20px
  }
  .captchatNew{
    margin: 0px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
</style>
